import { render, staticRenderFns } from "./IcoEndoso.vue?vue&type=template&id=4cb033c8"
import script from "./IcoEndoso.vue?vue&type=script&lang=ts"
export * from "./IcoEndoso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports